package com.milta.core.localization.translations.it

import com.milta.core.localization.ErrorStrings

internal val Errors = ErrorStrings(
    generic = "Si è verificato un errore",
    error = "Errore",
    fieldRequired = "Questo campo è obbligatorio",
    invalidEmail = "Indirizzo email non valido",
    fileTooLarge = "File troppo grande. Scegli un file più leggero.",
)
